import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import SessionStorage from '../util/sessionstore'

const session = new SessionStorage()
const service = new ApolloClientService()

export default class SignIn {
  updateSignature = (signature, userid) => {
    return new Promise((resolve, reject) => {
      service
        .updateSignature({ signature, userid })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  getUsers = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getUsers(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = data.status
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getCompanyHealthcoach = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getCompanyHealthcoach(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = data.status
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  addEditUser = (params, id) => {
    return new Promise((resolve, reject) => {
      if (params?.role) params.role = parseInt(params?.role)
      service
        .addEditUser(params, id)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  deleteUser = (id) => {
    return new Promise((resolve, reject) => {
      service
        .deleteUser(id)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  putPatientOnHold = (isNew, patientid) => {
    return new Promise((resolve, reject) => {
      service
        .putPatientOnHold(isNew, patientid)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
}
